module.exports = __webpack_public_path__ + "static/media/check.9d4753b9.svg";